"use strict";
var history_1 = require('history');
/* tsline:enable */
var most_1 = require('most');
function history(options) {
    var h = history_1.createHistory(options);
    var push = function (l) { return h.push(l); };
    var replace = function (l) { return h.replace(l); };
    var stream = new most_1.Stream(new HistorySource(h));
    return { push: push, replace: replace, stream: stream };
}
exports.history = history;
function hashHistory(options) {
    var h = history_1.createHashHistory(options);
    var push = function (l) { return h.push(l); };
    var replace = function (l) { return h.replace(l); };
    var stream = new most_1.Stream(new HistorySource(h));
    return { push: push, replace: replace, stream: stream };
}
exports.hashHistory = hashHistory;
var HistorySource = (function () {
    function HistorySource(history) {
        this.history = history;
    }
    HistorySource.prototype.run = function (sink, scheduler) {
        var push = function (l) { return sink.event(scheduler.now(), l); };
        var unlisten = this.history.listen(push);
        return {
            dispose: function () {
                unlisten();
                sink.end(scheduler.now());
            }
        };
    };
    return HistorySource;
}());
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/most-history/lib/index.js
// module id = 1539
// module chunks = 0